import React, { useEffect, useState } from "react";
import loginURLConfig from "../../../config/login/loginURLConfig";
import { passwordHints } from "../../../Containers/Constants/commenFeatures";
import { SIGNUP_FORM } from "../../../Containers/vendor/Signup/signupConstensts";
import { accRedircet } from "../../../services/genralServise";
import EdButton from "../../generic/edButton";
import InputField from "../../generic/inputField";
import ConfirmPassword from "../../generic/confirmPassword";
import { emailRegex, checkPasswordStranth } from "../../utils/regex";

export interface IVendorSignupProps {
  disableForm?: boolean;
  signupForm: SIGNUP_FORM;
  signupFormErr: SIGNUP_FORM;
  setSignupForm: (val: SIGNUP_FORM) => void;
  setSignupFormErr: (err: SIGNUP_FORM) => void;
  submitSignupForm: (e: React.FormEvent<HTMLFormElement>) => void;
}

const VendorSignup: React.FC<IVendorSignupProps> = (props) => {
  const [showPasswordHint, setShowPasswordHint] = useState<Array<string>>([]);

  useEffect(() => {
    let listOfStr: Array<string> = [];
    let getStrength;
    if (props.signupForm.password.length === 0) {
      getStrength = passwordHints;
    } else {
      getStrength = checkPasswordStranth(
        6,
        12,
        props.signupForm.password,
        props.signupForm.email
      );
    }
    for (let list in getStrength) {
      if (getStrength[list] !== "") {
        listOfStr.push(getStrength[list]);
      }
    }

    setShowPasswordHint(listOfStr);
  }, [props.signupForm.password]);

  useEffect(() => {
    if (showPasswordHint.length === 0 || !props.signupForm.password) {
      props.setSignupFormErr({
        ...props.signupFormErr,
        password: "",
      });
    }
  }, [showPasswordHint]);

  return (
    <div className="login_form">
      <form onSubmit={(e) => props.submitSignupForm(e)}>
        <label className="inp_lbl mg-b5 ib">Email ID</label>
        <InputField
          id="emailId"
          type="nonChangeable"
          pattern={emailRegex}
          defaultValue={props.signupForm.email}
          onChange={() => {}}
          onBlur={(error) => {
            props.setSignupFormErr({
              ...props.signupFormErr,
              email: error.pattern ? "" : "Please enter a valid email id",
            });
          }}
          className="login_inp mg-b30"
          placeholder="Eg: example@email.com"
          errorText={props.signupFormErr.email}
          autoComplete="off"
        />

        <ConfirmPassword
          form={props.signupForm}
          error={props.signupFormErr}
          showPasswordHint={showPasswordHint}
          onChange={props.setSignupForm}
          setError={props.setSignupFormErr}
        />

        {/* Show error if any */}
        {/* {props.errorMsg && (
          <LoginErrMsg className="mg-b40">{props.errorMsg}</LoginErrMsg>
        )} */}

        {/* Disable button if username or password is blank or form is disabled from outside */}
        <EdButton
          value="Proceed"
          btnTyp="primary"
          className="submit_btn mg-b30"
          disabled={
            Object.values(props.signupFormErr).some((error) => error) ||
            Object.values(props.signupForm).some((value) => !value) ||
            props.disableForm
          }
        />
      </form>
      <div className="login_frm_btm_txt">
        <p>
          New to Nuvama?{" "}
          <EdButton
            value="Open An Account"
            btnTyp="blue-link"
            className="link_btn mg-b30"
            onClick={() => accRedircet(loginURLConfig.openAccount)}
          />
        </p>
      </div>
    </div>
  );
};

export default VendorSignup;
